import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import {
  Edit,
  DeleteOutline,
  Refresh,
  Build,
  LinkOff,
} from "@material-ui/icons";

const ConnectionContextMenu = ({
  anchorEl,
  onClose,
  selectedWhatsApp,
  onEdit,
  onDelete,
  onRestart,
  onDisconnect,
  onCleanSession,
}) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
  >
    <MenuItem onClick={onEdit}>
      <Edit style={{ marginRight: 8, fontSize: 18 }} />
      Editar
    </MenuItem>
    {selectedWhatsApp?.canStop && (
      <MenuItem onClick={onDisconnect}>
        <LinkOff style={{ marginRight: 8, fontSize: 18, color: '#f44336' }} />
        <span style={{ color: '#f44336' }}>Detener</span>
      </MenuItem>
    )}
    <MenuItem onClick={onDelete}>
      <DeleteOutline style={{ marginRight: 8, fontSize: 18 }} />
      Borrar
    </MenuItem>
    {(selectedWhatsApp?.canRestart ?? true) && (
      <MenuItem onClick={onRestart}>
        <Refresh style={{ marginRight: 8, fontSize: 18 }} />
        Reiniciar
      </MenuItem>
    )}
    {selectedWhatsApp?.canCleanSession && (
      <MenuItem onClick={onCleanSession}>
        <Build style={{ marginRight: 8, fontSize: 18, color: '#ff9800' }} />
        <span style={{ color: '#ff9800', fontWeight: 'bold' }}>Limpiar y Reconectar</span>
      </MenuItem>
    )}
  </Menu>
);

export default ConnectionContextMenu;
